import {Button, Dropdown, DropdownItem} from 'platform/components';

import {type InterestDecisionReasonCodeValue} from '@dms/api/interest-recommendations';
import i18n from '@dms/i18n';

interface RejectReasonMenuProps {
  onReject: (reason: InterestDecisionReasonCodeValue) => void;
  isDisabled?: boolean;
  isLoading?: boolean;
}

export function RejectReasonMenu(props: RejectReasonMenuProps) {
  const reasons = [
    {
      code: 'ALREADY_HANDLED',
      label: i18n.t('entity.interestRecommendations.rejectReasons.alreadyHandled', {
        defaultValue: 'Already handled',
      }),
    },
    {
      code: 'NOT_INTERESTED',
      label: i18n.t('entity.interestRecommendations.rejectReasons.notInterested', {
        defaultValue: 'Customer is not interested',
      }),
    },
    {
      code: 'BAD_TIMING',
      label: i18n.t('entity.interestRecommendations.rejectReasons.badTiming', {
        defaultValue: 'Bad timing',
      }),
    },
    {
      code: 'DISAGREE_PRIORITY',
      label: i18n.t('entity.interestRecommendations.rejectReasons.disagreePriority', {
        defaultValue: 'Different priority',
      }),
    },
    {
      code: 'WRONG_RECOMMENDATION',
      label: i18n.t('entity.interestRecommendations.rejectReasons.wrongRecommendation', {
        defaultValue: 'Wrong recommendation',
      }),
    },
  ] satisfies {code: InterestDecisionReasonCodeValue; label: string}[];

  return (
    <Dropdown
      isDisabled={props.isDisabled}
      dropdownControl={
        <Button
          variant="ghost"
          size="small"
          title={i18n.t('general.actions.reject')}
          isDisabled={props.isDisabled}
          isLoading={props.isLoading}
        />
      }
    >
      {reasons.map((reason) => (
        <DropdownItem
          key={reason.code}
          label={reason.label}
          isDisabled={props.isDisabled}
          onClick={() => props.onReject(reason.code)}
        />
      ))}
    </Dropdown>
  );
}
